import {useMemo} from 'react'

interface UseAccessesCardFilterChecksProps {
    filters?: string
    filterKeys: string[]
}

interface UseAccessesCardFilterChecksReturn {
    isFiltering: boolean
    isFilteringFor: (key: string) => boolean
    activeFilters: string[]
}

/**
 * Hook to check if specific filter keys are present in a filters string
 * @param filters - The filters string to check
 * @param filterKeys - Array of filter keys to check for
 * @returns Object with filtering state and helper functions
 */
export const useAccessesCardFilterChecks = ({
    filters,
    filterKeys
}: UseAccessesCardFilterChecksProps): UseAccessesCardFilterChecksReturn => {
    const activeFilters = useMemo(() => {
        if (!filters) return []
        return filterKeys.filter(key => filters.includes(key))
    }, [filters, filterKeys])

    const isFiltering = useMemo(() => {
        return activeFilters.length > 0
    }, [activeFilters])

    const isFilteringFor = useMemo(() => {
        return (key: string): boolean => {
            return activeFilters.includes(key)
        }
    }, [activeFilters])

    return {
        isFiltering,
        isFilteringFor,
        activeFilters
    }
}
